import { createDataSelectors } from "@app/modules/app.reducers";
import { Storage } from "@ea/shared_types/types";

export const storageDataSelectors = createDataSelectors<Storage>()("storage");
